import { apiGet, apiPost, apiPut, apiDelete } from '../../generic/Api_Functions'
import { useAuthorization } from '../../generic/hooks/useAuthorization'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import PriorityConditionChecker from '../../generic/utilities/PriorityConditionChecker'

const Customer = () => {
  const { t_ } = useSmartTranslation()
  const isUserAuthorized = useAuthorization()

  const dataFetch = async (requestPagination) => {
    const response = await apiGet('clients', requestPagination)
    return response
  }
  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      charLimit: 60,
      mandatory: true,
      unique: true
    },
    {
      name: t_('Name'),
      field: 'name',
      charLimit: 80,
      mandatory: true
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200
    },
    {
      name: t_('Priority'),
      field: 'priority',
      numeric: true,
      mandatory: true,
      defaultNewValue: 5,
      condition: (row) => {
        return PriorityConditionChecker(row.priority, t_)
      }
    }
  ]
  const actions = {
    edit: {
      fetchFunction: (row) => {
        return apiPut('clients', row)
      },
      disabled: !isUserAuthorized('EDIT_CLIENT')
    },
    create: {
      fetchFunction: (row) => {
        return apiPost('clients', row)
      },
      disabled: !isUserAuthorized('ADD_CLIENT')
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('clients/' + rows[0].id)
        } else {
          return apiDelete('clients', rows)
        }
      },
      disabled: !isUserAuthorized('DELETE_CLIENT')
    }
  }

  return (
    <>
      <SmartMateriaUITable
        tableTuneUniqueKey='clients'
        columns={columns}
        title={t_('Customers')}
        dataFetch={dataFetch}
        multipleOptions
        multipleSelection
        actions={actions}
        pageable
        safeDeleteShowProperty='code'
      />
    </>
  )
}

export default Customer
